export const willTriggerDeferredExamNotification = ({
  deferredExamPrescriptionState,
}) => {
  return deferredExamPrescriptionState === 'draft';
};
